export default "__VITE_ASSET__8d31151f__"